import tour1 from "./images/project-1.png";
import tour2 from "./images/project-2.jpg";
import tour3 from "./images/project-3.png";
import tour4 from "./images/project-4.png";

export const pageLinks = [
  { id: 1, href: "#home", text: "home" },
  { id: 2, href: "#about", text: "about" },
  { id: 3, href: "#services", text: "services" },
  { id: 4, href: "#projects", text: "projects" },
  { id: 5, href: "#contact", text: "contact" },
];

export const socialLinks = [
  // {
  //   id: 1,
  //   href: "https://www.twitter.com",
  //   rel: "noreferrer",
  //   icon: "fab fa-facebook",
  // },
  // {
  //   id: 2,
  //   href: "https://www.twitter.com",
  //   rel: "noreferrer",
  //   icon: "fab fa-twitter",
  // },
  {
    id: 3,
    href: "https://wa.me/message/44SZSLJI5OJNO1",
    rel: "noreferrer",
    icon: "fab fa-whatsapp",
  },
];

export const projects = [
  {
    id: 1,
    img: tour1,
    date: "july 26th, 2022",
    title: "Financial Site",
    text: "A comprehensive online platform designed to empower users in effectively managing their finances. This site offers intuitive tools to meticulously track all financial transactions, ensuring users have a real-time overview of their monetary activities. Automated features assist in maintaining accurate balances and generate detailed account statements, providing users with valuable insights into their financial health.",
    city: "......",
    days: "3 months",
    price: "GHC....",
  },

  {
    id: 2,
    img: tour2,
    date: "augest 26th 2022",
    title: "Fitness Site",
    text: "A fitness-oriented website designed to assist users in achieving their health and wellness goals. This site provides a platform for users to log and track their workouts, set fitness goals, and monitor their progress over time. It may also include features like workout routines, nutritional guidance, and community forums for users to connect and share their fitness journeys.",
    city: ".......",
    days: "3 months",
    price: "GHC....",
  },
  {
    id: 3,
    img: tour3,
    date: "may 15th, 2023",
    title: "Car Rental Site",
    text: "A platform dedicated to facilitating the rental of vehicles. This site allows users to browse and choose from a variety of cars based on their preferences and needs. Users can make reservations, view rental terms, and manage bookings online. Additionally, the site may provide information about available insurance options, pricing details, and pick-up/drop-off locations to make the car rental process seamless.",
    city: "......",
    days: "2 months",
    price: "GHC....",
  },
  {
    id: 4,
    img: tour4,
    date: "december 5th, 2023",
    title: "Task Management Site",
    text: "A web-based application designed to help individuals and teams organize and manage tasks efficiently. This site typically offers features such as task creation, assignment, prioritization, and tracking. Users can set deadlines, create task lists, and collaborate with team members on various projects. The goal is to enhance productivity by providing a centralized platform for task management and effective communication within a team or organization.",
    city: "......",
    days: "2 months",
    price: "GHC....",
  },
];
